// Shared pricing constants to follow DRY principle
export interface PricingPlan {
  id: string;
  name: string;
  price: string;
  revenue: string;
  isPopular?: boolean;
  features: Array<{ name: string; description?: string | null }>;
}

/**
 * Dev Store plan is a special hardcoded plan for development/testing
 * All other plans are fetched dynamically from the backend
 */
export const DEV_STORE_PLAN = {
  id: "dev-store",
  name: "Dev Store",
  price: "0",
  revenue: "0% revenue fee",
  isPopular: false,
  features: [
    { name: "Test environment only", description: "Access to full platform for testing" },
    { description: "Full access to all features for testing", name: "Full access to all features for testing" },
    { description: "Unlimited affiliates (test only)", name: "Unlimited affiliates (test only)" },
    { description: "No revenue charges", name: "No revenue charges" },
    { description: "Documentation access", name: "Documentation access" },
  ],
  commissionRate: 0.0,
  limits: {
    approvedReferralsPerMonth: 'unlimited',
    maxAffiliates: 'unlimited',
    maxPrograms: 'unlimited',
  },
};

/**
 * Enterprise is not a purchasable plan — the highest self-serve tier tops out at
 * Scale, so large brands ask for a custom deal here and the team sets them up on a
 * private plan from the admin Plans page.
 */
export const ENTERPRISE_PLAN = {
  id: "enterprise",
  name: "Enterprise",
  price: "Custom",
  revenue: "Custom revenue fee",
  tagline: "For large brands that need a tailored deal",
  features: [
    "Everything in Scale",
    "Custom pricing & revenue fee",
    "Unlimited affiliates, programs & referrals",
    "Dedicated account manager & onboarding",
    "Priority support",
  ],
};

/** Self-reported store size, used by sales to triage the deal */
export const ENTERPRISE_REVENUE_OPTIONS = [
  "Under $100k / month",
  "$100k – $500k / month",
  "$500k – $1M / month",
  "$1M+ / month",
];

/**
 * Format commission rate as revenue fee percentage
 */
export function formatRevenueFee(commissionRate: number): string {
  const percentage = (commissionRate * 100).toFixed(1).replace('.0', '');
  return `${percentage}% revenue fee`;
}

export const PRICING_FOOTER_NOTE = "Transaction fee only applies to orders with a Reveshare generated discount code.";